import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';

import useLinkProps from '../../../hooks/use-link-props';
import HelpContacts from '../../modules/help-contacts';
import BPartsBicon from '../../ui/icons/bparts-b-icon';
import FeaturedLink from '../../ui/links/featured';

const HelpInfo = () => {
  const { t } = useTranslation();
  const getLink = useLinkProps();

  return (
    <>
      <div
        className={cx(
          'separator-bottom',
          'lg:separator-left',
          'py-6',
          'px-4',
          'flex',
          'flex-col',
          'gap-6'
        )}
      >
        <aside className="lg:order-2">
          <div className={cx('flex', 'items-center', 'mb-2')}>
            <BPartsBicon className={cx('h-12', 'w-12', 'mr-4')} />
            <div>
              <span className={cx('font-bold', 'tracking-wide')}>
                {t('password-reset:signup')}
              </span>
            </div>
          </div>
          <h2 className={cx('font-bold', 'tracking-wide')}>
            {t('password-reset:have-account')}
          </h2>

          <Link {...getLink('signup')} passHref legacyBehavior>
            <FeaturedLink>{t('password-reset:create-account')}</FeaturedLink>
          </Link>
        </aside>
        <HelpContacts />
      </div>
    </>
  );
};

export default HelpInfo;
